module.exports = __webpack_public_path__ + "566b3d66e82cf0fa2a757af5b2d56283.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-baseball-glove.png
// module id = 2579
// module chunks = 0